import React from 'react'
import { useTranslation } from 'react-i18next'
import type { AlternateNameConclusion, NameConclusion } from '@fs/zion-tree-types'
import { nameTypeKeyMap } from '../helpers/translationKeyMaps'

type NameTypeProps = {
  conclusion: NameConclusion | AlternateNameConclusion
}

export default function NameType({ conclusion }: NameTypeProps): JSX.Element | null {
  const [t] = useTranslation()
  const { nameType } = conclusion.details
  return nameType ? <span data-testid="conclusion-name-type">{t(nameTypeKeyMap[nameType])}</span> : null
}
